import React from 'react';
import { Card, Typography, TextField, Button, Stack, Box } from '@mui/material';

export default function AddComment({ open, onClose, onSubmit, initialValue = '' }) {
  const [text, setText] = React.useState(initialValue);

  React.useEffect(() => {
    setText(initialValue);
  }, [initialValue]);

  // Close on ESC key
  React.useEffect(() => {
    const handleEsc = (e) => e.key === 'Escape' && onClose();
    if (open) document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      {/* BACKDROP */}
      <Box
        onClick={onClose}
        sx={{
          position: 'fixed',
          inset: 0,
          backgroundColor: 'rgba(0,0,0,0.45)',
          backdropFilter: 'blur(2px)',
          zIndex: 9998,
        }}
      />

      {/* MODAL */}
      <Card
        sx={{
          p: 3,
          width: 420,
          maxWidth: '95%',
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          maxHeight: '90vh',
          overflowY: 'auto',
          zIndex: 9999,
        }}
      >
        <Typography variant="h6" mb={2}>
          {initialValue ? 'Edit Comment' : 'Add Comment'}
        </Typography>

        <TextField
          fullWidth
          multiline
          rows={4}
          placeholder="Write your comment..."
          value={text}
          onChange={(e) => setText(e.target.value)}
        />

        <Stack direction="row" spacing={2} mt={2} justifyContent="flex-end">
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>

          <Button
            variant="contained"
            disabled={!text.trim()}
            onClick={() => {
              onSubmit(text.trim());
              setText('');
              onClose();
            }}
          >
            Submit
          </Button>
        </Stack>
      </Card>
    </>
  );
}
